module.exports = __webpack_public_path__ + "img/markerX.d6d750de.png";